const equipamentosConstrucao = [
    { id: 1, descricao: "Escavadeira" },
    { id: 2, descricao: "Retroescavadeira" },
    { id: 3, descricao: "Guindaste" },
    { id: 4, descricao: "Caminhão betoneira" },
    { id: 5, descricao: "Compactador de solo" },
    { id: 6, descricao: "Pá carregadeira" },
    { id: 7, descricao: "Elevador de obras" },
    { id: 8, descricao: "Martelo pneumático" },
    { id: 9, descricao: "Plataforma elevatória" },
    { id: 10, descricao: "Tremonha" },
    { id: 11, descricao: "Vibrador de concreto" },
    { id: 12, descricao: "Gerador" },
    { id: 13, descricao: "Cortadora de piso" },
    { id: 14, descricao: "Soldador" },
    { id: 15, descricao: "Máquina de asfalto" },
    { id: 16, descricao: "Broca" },
    { id: 17, descricao: "Escada de alumínio" },
    { id: 18, descricao: "Furadeira de coluna" },
    { id: 19, descricao: "Serra de fita" },
    { id: 20, descricao: "Compressor de ar" },
    { id: 21, descricao: "Caminhão caçamba" },
    { id: 22, descricao: "Trator de esteira" },
    { id: 23, descricao: "Escavadeira hidráulica" },
    { id: 24, descricao: "Carregadeira" },
    { id: 25, descricao: "Caminhão munck" },
    { id: 26, descricao: "Dumper" },
    { id: 27, descricao: "Plataforma de trabalho" },
    { id: 28, descricao: "Cortadora de grama" },
    { id: 29, descricao: "Máquina de bordar" },
    { id: 30, descricao: "Máquina de nivelamento" },
    { id: 31, descricao: "Betoneira" },
    { id: 32, descricao: "Pavimentadora" },
    { id: 33, descricao: "Mini escavadeira" },
    { id: 34, descricao: "Pá manual" },
    { id: 35, descricao: "Serra circular" },
    { id: 36, descricao: "Máquina de solda" },
    { id: 37, descricao: "Furadeira portátil" },
    { id: 38, descricao: "Esmerilhadeira" },
    { id: 39, descricao: "Soprador" },
    { id: 40, descricao: "Ponto de energia" },
    { id: 41, descricao: "Máquina de corte a plasma" },
    { id: 42, descricao: "Plataforma de elevação" },
    { id: 43, descricao: "Cortadora de azulejos" },
    { id: 44, descricao: "Rolo compactador" },
    { id: 45, descricao: "Máquina de prensagem" },
    { id: 46, descricao: "Equipamento de solda" },
    { id: 47, descricao: "Bancada de trabalho" },
    { id: 48, descricao: "Carrinho de mão" },
    { id: 49, descricao: "Mangueira de ar" },
    { id: 50, descricao: "Escavadeira de pequeno porte" },
    { id: 51, descricao: "Elevador de carga" },
    { id: 52, descricao: "Máquina de terraplanagem" },
    { id: 53, descricao: "Placa vibratória" },
    { id: 54, descricao: "Máquina de jateamento" },
    { id: 55, descricao: "Gerador de energia" },
    { id: 56, descricao: "Unidade de refrigeração" },
    { id: 57, descricao: "Moinho de martelo" },
    { id: 58, descricao: "Separador de materiais" },
    { id: 59, descricao: "Torre de iluminação" },
    { id: 60, descricao: "Caminhão de transporte" },
    { id: 61, descricao: "Container de armazenamento" },
    { id: 62, descricao: "Sistema de ventilação" },
    { id: 63, descricao: "Bandeja de transporte" },
    { id: 64, descricao: "Máquina de injeção" },
    { id: 65, descricao: "Equipamento de perfuração" },
    { id: 66, descricao: "Máquina de lavagem de alta pressão" },
    { id: 67, descricao: "Cortadora de metais" },
    { id: 68, descricao: "Máquina de corte de grama" },
    { id: 69, descricao: "Máquina de mistura" },
    { id: 70, descricao: "Unidade de mistura" },
    { id: 71, descricao: "Bomba submersível" },
    { id: 72, descricao: "Bomba de concreto" },
    { id: 73, descricao: "Cortadora de tubos" },
    { id: 74, descricao: "Motobomba" },
    { id: 75, descricao: "Gerador de oxigênio" },
    { id: 76, descricao: "Equipamento de escaneamento" },
    { id: 77, descricao: "Máquina de polimento" },
    { id: 78, descricao: "Máquina de marcenaria" },
    { id: 79, descricao: "Equipamento de inspeção" },
    { id: 80, descricao: "Máquina de pneumáticos" },
    { id: 81, descricao: "Carro de força" },
    { id: 82, descricao: "Elevador de andaime" },
    { id: 83, descricao: "Escavadeira de perfuração" },
    { id: 84, descricao: "Máquina de manuseio de materiais" },
    { id: 85, descricao: "Furadeira de impacto" },
    { id: 86, descricao: "Soldador a gás" },
    { id: 87, descricao: "Máquina de revestimento" },
    { id: 88, descricao: "Cortadora de papel" },
    { id: 89, descricao: "Máquina de dobra" },
    { id: 90, descricao: "Gerador solar" },
    { id: 91, descricao: "Compactador de asfalto" },
    { id: 92, descricao: "Escavadeira de lagos" },
    { id: 93, descricao: "Empilhadeira" },
    { id: 94, descricao: "Máquina de contagem" },
    { id: 95, descricao: "Máquina de exaustão" },
    { id: 96, descricao: "Máquina de agulhamento" },
    { id: 97, descricao: "Plataforma de acesso" },
    { id: 98, descricao: "Máquina de iluminação" },
    { id: 99, descricao: "Carro de transporte" },
    { id: 100, descricao: "Concreto usinado" }
];

export default equipamentosConstrucao;